module.exports = __webpack_public_path__ + "img/all.27bbc92a.svg";